import { useCallback, useEffect } from 'react';
import './hashVerify.css';
import { SpinnerCircular } from 'spinners-react';
import { setAccountId, setPartnerInfo } from '../utils/storage';
import api from '../utils/api';
import { handleApiError } from '../utils/apiError';
import { useParams, useNavigate } from 'react-router-dom';
import useLogger from '../hooks/useLogger';
import { HASH_VERIFICATION_ACTIONS, LOG_STATUSES } from '../logging/LoggingConstants';
import { readPartnerInfo } from '../utils/partnerRedirectFlow';

type PartnerHashVerifyResponse = {
    accountId: string;
    email?: string;
    phone?: string;
    docType?: number;
    docNumber?: string;
    partnerRedirectUrl?: string;
    partnerInfo?: Record<string, unknown>;
};

const HashVerify = () => {
    const navigate = useNavigate();
    const { hash, partnerId } = useParams<{ hash: string; partnerId: string }>();
    const { log } = useLogger();

    const hashVerify = useCallback(() => {
        (api.post(`/account/partner/${partnerId}`, { hash }) as Promise<PartnerHashVerifyResponse>)
            .then((e) => {
                log(HASH_VERIFICATION_ACTIONS.HASH_VERIFICATION_SUCCESS, LOG_STATUSES.SUCCESS);
                setAccountId(e.accountId);
                const partnerInfo = readPartnerInfo(e.partnerInfo);
                setPartnerInfo({
                    email: e.email,
                    phone: e.phone,
                    docType: e.docType,
                    docNumber: e.docNumber,
                    partnerRedirectUrl: e.partnerRedirectUrl,
                    ...(partnerInfo ? { partnerInfo } : {}),
                });
                navigate('/');
            })
            .catch((e: unknown) => handleApiError(e, navigate));
    }, [hash, partnerId, navigate, log]);

    useEffect(() => {
        hashVerify();
    }, [hashVerify]);

    return (
        <div className='verify-wrapper'>
            <SpinnerCircular size={150} thickness={200} />
        </div>
    );
};

export default HashVerify;
